import type { TOC } from '@ember/component/template-only';

import BoardTemplatesRecommendedAccountTemplatesComponent from 'webapp/components/board/templates/recommended-account-templates';
import EmptyScreensBoardAccountTemplatesComponent from 'webapp/components/empty-screens/board-account-templates';
import TemplatesAccountGridComponent from 'webapp/components/templates/account/grid';
import TemplatesAccountRecommendedComponent from 'webapp/components/templates/account/recommended';
import TemplatesAccountRecommendedBoardTemplatesComponent from 'webapp/components/templates/account/recommended-board-templates';
import type BoardsAccountTemplatesController from 'webapp/controllers/boards/account-templates';

interface Args {
	controller: BoardsAccountTemplatesController;
}

const BoardsAccountTemplatesRouteTemplate: TOC<Args> = <template>
	<div class="container__recommended">
		{{#if @controller.hasCurrentSpaceModels}}
			<div id="account-templates" class="view-grid">
				<TemplatesAccountGridComponent
					@model={{@controller.model}}
					@createTemplate={{@controller.createTemplate}}
					@useTemplate={{@controller.useTemplate}}
					@previewTemplate={{@controller.previewTemplate}}
					@openTemplatePermissions={{@controller.openTemplatePermissions}}
					@editTemplate={{@controller.editTemplate}}
					@deleteTemplate={{@controller.deleteTemplate}}
				/>
			</div>
		{{else}}
			<EmptyScreensBoardAccountTemplatesComponent />

			{{#if @controller.showRecommendedBoards}}
				<BoardTemplatesRecommendedAccountTemplatesComponent />
			{{else if @controller.showRecommendedAccountTemplates}}
				<TemplatesAccountRecommendedComponent />
			{{else}}
				<TemplatesAccountRecommendedBoardTemplatesComponent />
			{{/if}}
		{{/if}}

	</div>
</template>;

export default BoardsAccountTemplatesRouteTemplate;
